import * as React from 'react'
import {
  Args,
  DestructuredURL,
  ToggleFollowingAction,
  ToggleFollowingOutput,
  ToggleFollowingTag,
  withArgs,
} from '@utils'
import { ToggleFollowingButton } from '@shared/person/toggleFollowingButton/ToggleFollowingButton'
import { ToggleFollowingButtonType } from './ToggleFollowingButton'
import { atv } from 'DVWebNodeWpsRuntime'

interface FollowingButtonContainerProps extends Args {
  toggleFollowingAction: atv.wps.ToggleFollowingActionProps | ToggleFollowingAction;
  buttonType?: ToggleFollowingButtonType;
  className?: string;
}

interface FollowingButtonContainerState {
  toggleFollowingAction: ToggleFollowingAction;
}

const getToggleFollowingAction = (action: atv.wps.ToggleFollowingActionProps | ToggleFollowingAction): ToggleFollowingAction => {
  const {tag, text, endpoint} = action
  return {tag: tag as ToggleFollowingTag, text, endpoint: endpoint as DestructuredURL}
}

class Container extends React.Component<FollowingButtonContainerProps, FollowingButtonContainerState> {
  constructor(props: FollowingButtonContainerProps) {
    super(props)
    this.state = {
      toggleFollowingAction: getToggleFollowingAction(props.toggleFollowingAction)
    }
  }

  onToggleFollowingSuccess = (res: ToggleFollowingOutput) => {
    res.newAction && this.setState({
      toggleFollowingAction: res.newAction
    })
  }

  render() {
    const { buttonType, className, context, logger } = this.props
    const { toggleFollowingAction } = this.state
    return <ToggleFollowingButton {...{
      ...toggleFollowingAction,
      context,
      logger,
      onSuccess: this.onToggleFollowingSuccess,
      buttonType,
      className
    }}/>
  }
}

export const FollowingButtonContainer = withArgs(Container)
